import * as React from "react";
export function Popup({ content, label }) {
    const [isShown, setIsShown] = React.useState(false);
    function togglePopup() {
        setIsShown(!isShown);
    }
    return (React.createElement("div", { className: "popupWrapper" },
        React.createElement("button", { onClick: togglePopup }, label),
        isShown &&
            React.createElement("div", { className: "popup" }, content)));
}
//# sourceMappingURL=Popup.js.map